/** Справочник: темы изучаемого языка, карточки темы и прогресс ученика (на сервере). */

import type { ReferenceProgressEvent, ReferenceProgressImport, ReferenceProgressView, ReferenceTopicDetail, ReferenceTopicView } from '@aptile/shared';

import { apiRequest, jsonBody } from './client';

export function fetchReferenceTopics(): Promise<readonly ReferenceTopicView[]> {
  return apiRequest<readonly ReferenceTopicView[]>('/api/reference/topics');
}

export function fetchReferenceTopic(topicId: string): Promise<ReferenceTopicDetail> {
  return apiRequest<ReferenceTopicDetail>(`/api/reference/topics/${encodeURIComponent(topicId)}`);
}

export function fetchReferenceProgress(): Promise<ReferenceProgressView> {
  return apiRequest<ReferenceProgressView>('/api/reference/progress', { cache: 'no-store' });
}

export function sendReferenceEvent(topicId: string, event: ReferenceProgressEvent): Promise<ReferenceProgressView> {
  return apiRequest<ReferenceProgressView>(`/api/reference/progress/${encodeURIComponent(topicId)}`, { method: 'POST', body: jsonBody(event) });
}

export function importReferenceProgress(data: ReferenceProgressImport): Promise<ReferenceProgressView> {
  return apiRequest<ReferenceProgressView>('/api/reference/progress-import', { method: 'POST', body: jsonBody(data) });
}

export function skipReferenceSandbox(): Promise<ReferenceProgressView> {
  return apiRequest<ReferenceProgressView>('/api/reference/sandbox/skip', { method: 'POST', body: jsonBody({}) });
}
